import React from "react";
import {
  AutocompleteArrayInput,
  Edit,
  ReferenceArrayInput,
  SaveButton,
  SimpleForm,
  Toolbar,
  FunctionField,
} from "react-admin";
import { Typography } from "@material-ui/core";
import { ReadOnlyField } from "lib/components/ReadOnlyField";
import { RandomizePersonalizedPlaylistButton } from "./components/RandomizePersonalizedPlaylistButton";
import { SubscriptionStatusBadge } from "../components/SubscriptionStatusBadge";
import { SyncRevenueCatButton } from "./components/SyncRevenueCatButton";

export function UserEdit(props) {
  return (
    <Edit {...props} mutationMode="pessimistic">
      <SimpleForm
        toolbar={<UserEditToolbar />}
        validate={validateUser}
        warnWhenUnsavedChanges
      >
        <Typography variant="h6" style={{ marginBottom: "1rem" }}>
          User Information
        </Typography>
        <ReadOnlyField addLabel label="Email" source="email" />
        <ReadOnlyField addLabel label="UID" source="uid" />
        <ReadOnlyField addLabel label="ID" source="id" />

        <Typography
          variant="h6"
          style={{ marginTop: "2rem", marginBottom: "1rem" }}
        >
          Subscription Details
        </Typography>
        <FunctionField
          addLabel
          label="Status"
          render={(record) => {
            if (!record?.primarySubscription) {
              return <SubscriptionStatusBadge />;
            }
            return (
              <SubscriptionStatusBadge
                status={record.primarySubscription.status}
              />
            );
          }}
        />
        <ReadOnlyField
          addLabel
          label="Provider"
          source="primarySubscription.provider.name"
        />
        <ReadOnlyField
          addLabel
          label="Provider ID"
          source="primarySubscription.provider.id"
        />
        <ReadOnlyField
          addLabel
          label="Subscription ID"
          source="primarySubscription.id"
          render={(record) => {
            const id = record?.primarySubscription?.id;
            if (!id) {
              return "N/A";
            }
            return (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => navigator.clipboard.writeText(id)}
                title="Click to copy"
              >
                {id}
              </span>
            );
          }}
        />
        <SyncRevenueCatButton />

        <Typography
          variant="h6"
          style={{ marginTop: "2rem", marginBottom: "1rem" }}
        >
          User Roles & Settings
        </Typography>
        <RandomizePersonalizedPlaylistButton />
        <ReferenceArrayInput label="Role" source="roles" reference="roles">
          <AutocompleteArrayInput optionValue="name" allowEmpty />
        </ReferenceArrayInput>
      </SimpleForm>
    </Edit>
  );
}

function UserEditToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

function validateUser(values) {
  const errors = {};
  const required = ["email"];

  required.forEach((requiredField) => {
    if (!values[requiredField]) {
      errors[requiredField] = ["ra.validation.required"];
    }
  });

  return errors;
}
